import React from 'react';
import { useThemeToken } from '@/hooks';
import { HistoryTopic } from '@@service/api';
import { SvgIcon } from '@/base-components';
import './index.less';

// eslint-disable-next-line no-unused-vars
type TopicClickHandler = (topicId: string, topicText: string) => void;

export interface HistoryTopicListProps {
    topics: HistoryTopic[];
    onTopicClick: TopicClickHandler;
}

const HistoryTopicList: React.FC<HistoryTopicListProps> = ({ topics, onTopicClick }) => {
    const { colorLink } = useThemeToken();

    return (
        <div className="history-topic-list" role="region" aria-label="Historical issues">
            <h2 className="history-topic-list-title">Historical Issue</h2>
            <ul className="history-topic-list-items">
                {topics.map((item) => (
                    <li key={item.id} className="history-topic-item">
                        <SvgIcon
                            name="history-chat"
                            color={colorLink}
                        />
                        <button
                            type="button"
                            className="history-topic-link"
                            onClick={() => {
                                onTopicClick(item.id, item.topic);
                            }}
                        >
                            {item.topic}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HistoryTopicList;
